import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { ReportsService } from "../services/reports.service";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import * as moment from "moment";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { map, startWith, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { UntypedFormControl } from "@angular/forms";
@Component({
  selector: 'app-non-starter-case',
  templateUrl: './non-starter-case.component.html',
  styleUrls: ['./non-starter-case.component.scss']
})
export class NonStarterCaseComponent implements OnInit {
  showSpinner: boolean = false;
  dataSource: any;
  JsonData: any;
  displayedColumns: string[] = [
    "#",
    "LoanAcNo",
    "Customer_Name",
    "Customer_PhoneNo",
    "Branch_Name",
    "Product_Name",
    "Loan_Date",
   "Loan_Amount",
    "Current_DueDate",
    "First_EMI_Date",
    "OverDue_Amount",
    "DPD",
    "EMI_Amount",
    "Mature_EMI",
    "InNACHPDC"
  ]
  DataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  BranchesList: any;
  ProductList: any;
  SalesExecutiveData: any;
  SelectBranch: any = "All";
  ProductId: any = "All";
  SalesEx: any = "All";
  NoOfEmi: any;
  SalesExId: any;
  SalesExName: any;
  SalesExecutiveCtrl: UntypedFormControl = new UntypedFormControl();
  ToDate: any = new Date();
  currentUser: any;
  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,

    private snackBar: MatSnackBar,
    private lmsService: LmsService) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Non Starter Case");

    this.getBranchesList();
    this.getProductDropdown();
    this.GetSalesExecutive();

  }
  onSearch() {
    this.showSpinner = true;
    this.reportsService
      .Report_NonStarter_Case({
        toDate: this.ToDate,
        BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
        ProductId: this.ProductId == "All" ? 0 : this.ProductId,
        SalesExecutive: this.SalesEx == "All" ? 0 : this.SalesEx,
        MaxEmiCount: this.NoOfEmi && this.NoOfEmi > 0 ? this.NoOfEmi : 0
      })
      .subscribe((res: any) => {
        console.log("Report :", res);
        this.JsonData = res;
        this.DataSource = new MatTableDataSource(
          JSON.parse(JSON.stringify(res))
        );
        this.DataSource.paginator = this.paginator;
        this.DataSource.sort = this.sort;
        this.showSpinner = false;
      });
  }
getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  getProductDropdown() {
    this.MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
        // console.log("Product List", this.ProductList);
      });
  }
  
  GetSalesExecutive() {
    this.lmsService
      .Get_Collection_Ex_By_UserId({
        LoginUserId: this.currentUser.userId,
        BranchId: "",
      })
      .subscribe((res) => {
        this.SalesExecutiveData = JSON.parse(JSON.stringify(res));
      });
  }
  applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }
  
    

  exportExcel(): void {
  const uri = "data:application/vnd.ms-excel;base64,";
  const template =
    '<html xmlns:o="urn:schemas-microsoft-com:office:office" ' +
    'xmlns:x="urn:schemas-microsoft-com:office:excel" ' +
    'xmlns="http://www.w3.org/TR/REC-html40">' +
    "<head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets>" +
    "<x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions>" +
    "<x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>" +
    "</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>" +
    "<body><table>{table}</table></body></html>";

  const base64 = (s: string): string =>
    window.btoa(unescape(encodeURIComponent(s)));
  const format = (s: string, c: { [key: string]: string }): string =>
    s.replace(/{(\w+)}/g, (m, p) => c[p]);

  // Build table HTML from filtered data
  let tableHtml = "<tr>";
  // headers
  this.displayedColumns.forEach((col: string) => {
    tableHtml += `<th>${col}</th>`;
  });
  tableHtml += "</tr>";

  // rows
  this.DataSource.filteredData.forEach((row: any) => {
    tableHtml += "<tr>";
    this.displayedColumns.forEach((col: string) => {
      tableHtml += `<td>${row[col] ?? ""}</td>`;
    });
    tableHtml += "</tr>";
  });

  const worksheetName = "LOAN CUSTOMER DETAILS";
  const ctx = { worksheet: worksheetName, table: tableHtml };
  const downloadLink = document.createElement("a");

  downloadLink.href = uri + base64(format(template, ctx));
  downloadLink.download = worksheetName + ".xls";
  downloadLink.click();
}

}

